import { apiService } from "carynhealth-component-library";
import config from "../../config/constants/config";
import messages from "../../config/constants/messages";
import { publicIpv4 } from "public-ip";

const PlatformDetector = () => {
  const ua = navigator.userAgent.toLowerCase();
  const platform = /win/.test(ua)
    ? "Windows"
    : /mac/.test(ua)
    ? "MacOS"
    : /linux/.test(ua)
    ? "Linux"
    : /android/.test(ua)
    ? "Android"
    : /iphone|ipad/.test(ua)
    ? "iOS"
    : "Unknown";
  return platform;
};

export const getDateTime = () => {
  const tempDate = new Date();
  const format = (num: number) => String(num).padStart(2, "0");

  return (
    `${tempDate.getFullYear()}-${format(tempDate.getMonth() + 1)}-${format(
      tempDate.getDate()
    )} ` +
    `${format(tempDate.getHours())}:${format(tempDate.getMinutes())}:${format(
      tempDate.getSeconds()
    )}`
  );
};

export const getPublicIP = async () => {
  try {
    return await publicIpv4();
  } catch (error) {
    console.error("Failed to fetch public IP:", error);
    return null;
  }
};
export const getBrowser = () => {
  const ua = navigator.userAgent;

  if (/Chrome/.test(ua) && !/Edg|OPR|Brave/.test(ua)) return "Google Chrome";
  if (/Edg/.test(ua)) return "Microsoft Edge";
  if (/Firefox/.test(ua)) return "Mozilla Firefox";
  if (/Safari/.test(ua) && !/Chrome/.test(ua)) return "Safari";
  if (/OPR/.test(ua)) return "Opera";
  if (/YaBrowser/.test(ua)) return "Yandex Browser";
  if (/MSIE|Trident/.test(ua)) return "Internet Explorer";

  return "Others";
};
export const getDeviceType = () =>
  /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
    ? "mobile"
    : "computer";

export const getLoginCount = async () => {
  try {
    var os = PlatformDetector();
    var date = getDateTime();
    var publicIp = await getPublicIP();
    var browser = getBrowser();
    var deviceType = getDeviceType();
    let data = {
      username: localStorage.getItem("subscriberName"),
      cognitoUsername: localStorage.getItem("cognitoUsername"),
      phoneNumber: localStorage.getItem("contactNumber"),
      email: localStorage.getItem("userMail"),
      device:
        "Operating system : " +
        os +
        ",Web browser : " +
        browser +
        ",Device type : " +
        deviceType,
      ipOrigin: publicIp,
      lastLoggedin: date,
    };
    const request = {
      URL: config.URLS.baseAPI + config.URLS.loginCount,
      brand: config.BRAND_IP_AEC,
      data: data,
    };
    const { data: apiResponse } = await apiService.default.post(request);
    return apiResponse;
  } catch (error: any) {
    return Promise.reject({
      message: error?.message || messages.SOMETHING_WRONG,
    });
  }
};
